<template>
  <div :class="{'hashead':!isPC}">
    <WapHeader :title="''" v-if="!isPC" :showhome="true" :showlogo="true"></WapHeader>
    <HotRecom class="bmain" :isPC="isPC"></HotRecom>
    <Footer></Footer>
  </div>
</template>
<script>
import WapHeader from '@/components/public/WapHeader'
import Footer from '@/components/public/Footer'
import HotRecom from '@/components/public/HotRecom'
export default {
  name: 'recommendlist',
  components: {
    'WapHeader': WapHeader,
    'Footer': Footer,
    'HotRecom': HotRecom,
  },
  mounted(){
    var _this = this;

    
  },
  data() {
    return {
      isPC: this.$store.state.isPC
    }
  },
}

</script>
<style scoped>
  .bmain.hotrecommend{padding:0 0 20px;}
  .bmain.hotrecommend>>>ul{width:100%!important;height:auto;overflow:visible;}
  .bmain.hotrecommend>>>li{margin-left:3%;width:45.5%;margin-right:0;margin-top:15px;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);border-radius:4px;overflow:hidden;padding-bottom:8px;}
  .bmain.hotrecommend>>>li img{box-shadow:none;border-radius:0;height:110px;}
  .bmain.hotrecommend>>>li .hrtitle{padding-left:5px;padding-right:5px;}
</style>


// WEBPACK FOOTER //
// src/components/RecommendList.vue